import debug = require('debug')
import { PROJECT_NAME } from './config'

export default debug(PROJECT_NAME)
